module.exports = __webpack_public_path__ + "img/spa-yoga.6b9d283b.svg";